import createReactComponent from '../createReactComponent';
export default createReactComponent('cloud-fog', 'IconCloudFog', [
  [
    'path',
    {
      d: 'M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M5 20l14 0', key: 'svg-1' }],
]);
